import { Icon, IconProps } from '@chakra-ui/react';
import React from 'react';
import { JSX } from 'react/jsx-runtime';

const Menu = (props: JSX.IntrinsicAttributes & Omit<React.SVGProps<SVGSVGElement>, "as" | "translate" | keyof IconProps> & { htmlTranslate?: "yes" | "no" | undefined; } & IconProps & { as?: "svg" | undefined; }) => {
  return (
    <Icon
      xmlns='http://www.w3.org/2000/svg'
      boxSize='26px'
      viewBox='0 0 24 24'
      fill='none'
      stroke='#0f172a'
      strokeWidth='2.5'
      strokeLinecap='round'
      strokeLinejoin='round'
      {...props}
    >
      <line x1='3' y1='12' x2='21' y2='12'></line>
      <line x1='3' y1='6' x2='21' y2='6'></line>
      <line x1='3' y1='18' x2='21' y2='18'></line>
    </Icon>
  );
};

export default Menu;
